module.exports = __webpack_public_path__ + "img/IMG_0374_L_Black_MockedUp.7d1af921.jpg";